import React from "react";
import { SettingsSelectBoxWrapper } from "../styled/styled";
import { useTranslation } from "react-i18next";
import SelectButton from "../selectButton/SelectButton";
import ContactsIcon from "@mui/icons-material/Contacts";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { AppSelectHandler } from "../types/common";
import { APPLICATION } from "../constants/common";

type Props = { onClick: AppSelectHandler };

const ApplicationsSelect: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation("common");

  return (
    <SettingsSelectBoxWrapper>
      <span>{t("applicationSelect.title")}</span>
      <SelectButton Icon={ContactsIcon} text={t("applicationSelect.customerServices")} onClick={onClick} value={APPLICATION.ODIN} />
      <SelectButton Icon={QrCodeScannerIcon} text={t("applicationSelect.kiosk")} onClick={onClick} value={APPLICATION.FREYA} />
    </SettingsSelectBoxWrapper>
  );
};

export default ApplicationsSelect;
